<!-- 库房报损 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                            @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0">
                                <el-form label-width="110px" id="mainInfo" class="baseForm" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                      :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <df-date @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" :isShowLong="false" :isdisabled="formOneValue.isChange == 0"
                                                     v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                            <!-- 检索方案 -->
                                            <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                          :disabled="sendDataInfo.reconciliationDetails.length > 0||formOneValue.isChange == 0">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                               icon="el-icon-search"
                                                               :disabled="sendDataInfo.reconciliationDetails.length > 0||formOneValue.isChange == 0">
                                                    </el-button>
                                                </el-input>
                                            </el-tooltip>
                                            <!-- 发起类型 -->
                                            <el-select @visible-change="(e) => { selectChange(e, formOneValue.focusField) }" @change="selectChanges" v-else-if="formOneValue.entityField == 'csrcType'"
                                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择" :disabled="sendDataInfo.reconciliationDetails.length > 0||formOneValue.isChange == 0">
                                                <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key"></el-option>
                                            </el-select>
                                            <!-- 发起类型 -->
                                            <el-select @visible-change="(e) => { selectChange(e, formOneValue.focusField) }" v-else-if="formOneValue.fieldType == 'formatter'"
                                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择" :disabled="sendDataInfo.reconciliationDetails.length > 0||formOneValue.isChange == 0">
                                                <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key"></el-option>
                                            </el-select>
                                            <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                      :maxlength="$store.state.inputLength" :disabled="sendDataInfo.reconciliationDetails.length > 0||formOneValue.isChange == 0"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <span v-if="formOneValue.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                       sendDataInfo[formOneValue.entityField]
                                    }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                </span>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                                    getValue(sendDataInfo[formOneValue.entityField],
                                       formOneValue.entityField, formOneValue.fieldType,
                                       formOneValue.formatterContent) }}</span>
                                            <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                       sendDataInfo[formOneValue.entityField] ==
                                          1 ? "是" : "否" }}</span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>

                                <!-- 明细 -->
                                <el-form :inline="true" size="mini" @submit.native.prevent>
                                    <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" v-if="sendDataInfo.csrcType === 1" size="mini" @click="extract1('sendDataInfo')">提取</el-button>
                                        <el-button type="primary" v-else size="mini" @click="extract('sendDataInfo')">提取</el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                        </el-button>
                                    </div>
                                    <el-table @row-click="rowClick" size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.reconciliationDetails" border style="width: 100%"
                                              :height="sendDataInfo.csrcType === 1?mxHeight/2:mxHeight">
                                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <template v-for="(formOneValue, formOneKey) in mxForm">
                                            <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :key="formOneKey"
                                                             v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <el-input :ref="formOneValue.entityField" @input="calculate(1, scope.$index)"
                                                              v-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1 && sendDataInfo.csrcType === 0"
                                                              v-model="sendDataInfo.reconciliationDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <!-- 有效期 -->
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="scope.row[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>
                                                        {{ sendDataInfo.reconciliationDetails[scope.$index][formOneValue.entityField] }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </template>

                                    </el-table>
                                    <el-table v-if="sendDataInfo.csrcType === 1" size="mini" ref="mxTableRef" id="mxTable" :data="detailsList" border style="width: 100%" :height="mxHeight/2">
                                        <template v-for="(formOneValue, formOneKey) in mxForm1">
                                            <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :key="formOneKey"
                                                             v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <!-- 有效期 -->
                                                    <span v-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="scope.row[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>
                                                        {{ detailsList[scope.$index][formOneValue.entityField] }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </template>

                                    </el-table>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <!-- 页脚 -->
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                        @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchSchemeOther :isRepetition="isRepetition" :isRepetitionList="isRepetitionList" :isProp="'bgsId'" ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                               @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog top="1vh" :title="seTitle" v-if="DialogExtract" :visible.sync="DialogExtract" width="70vw" :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeMultiple ref="searchSchemeMultiple" :id="seId" :parentData="parentData" :parentSearchData="parentSearchData" @TranData="changeInputModel" @selection="selection" @getWidth="getSeWidth" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogExtract = false">取 消</el-button>
                <el-button type="primary" @click="getExData">确认选择</el-button>
            </span>
        </el-dialog>
        <el-dialog top="1vh" title="提取寄售对账数据" v-if="DialogExtract1" :visible.sync="DialogExtract1" width="70vw" :modal-append-to-body='true' :append-to-body="true">
            <extractConsignmentReconciliation :parentData="parentData" v-if="DialogExtract1" :invoiceExtractData="invoiceExtractData" @invoiceExtractMethods="invoiceExtractMethods" ref="extractConsignmentReconciliation">
            </extractConsignmentReconciliation>
        </el-dialog>
        <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchSchemeMultiple from "../byComponents/SearchSchemeMultiple.vue";
import extractConsignmentReconciliation from '@/components/extractConsignmentReconciliation';
export default {
    name: "consignmentReconciliationAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchSchemeMultiple,
        extractConsignmentReconciliation
    },
    data() {
        //这里存放数据
        return {
            ormId: "",
            detailsFlag: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            detailsList: [],
            detaislDataInfo: {},
            detaislDataInfo1: {},
            selectGoodsInfo: "",
            showTabs: "",
            formDataList: [],
            parentSearchData: {},
            seTitle: "", //检索
            DialogVisible: false,
            nextSearch: false,
            isRepetitionList: [],
            isRepetition: false,
            seWidth: "0",
            seId: 0,
            selectedDetailsIndex: 0, //选择索引
            selectedDetailsIndex1: 0, //选择索引
            focusIndex: 0, //检索焦点索引
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            mxForm1: [],
            mxFormList: [],
            footForm: [],
            //-------提取
            DialogExtract: false,
            selectelist: [],
            parentData: {
                type: "dapdId",
                list: []
            },
            //---------提取寄售对账数据
            DialogExtract1: false,
            invoiceExtractData: {},
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.reconciliationDetails": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalCount = 0; //总条目数
                this.sendDataInfo.totalMoney = 0; // 总金额
                this.sendDataInfo.totalNumber = 0; // 总数量
                this.sendDataInfo.taxMoney = 0;//税额
                this.sendDataInfo.totalntaxMoney = 0;//不含税金额
                newValue.forEach((item, keys) => {
                    this.$set(this.sendDataInfo.reconciliationDetails[keys], 'recPnumber', this.$common.updataNum('recPnumber', item).recPnumber)
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(parseFloat(this.sendDataInfo.totalMoney), parseFloat(item.psmoney)))
                    this.sendDataInfo.totalntaxMoney = this.$common.getDecimalInfo(3, NP.plus(parseFloat(this.sendDataInfo.totalntaxMoney), parseFloat(item.money)))
                    this.sendDataInfo.taxMoney = this.$common.getDecimalInfo(3, NP.plus(parseFloat(this.sendDataInfo.taxMoney), parseFloat(item.taxAmount)))
                    this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(3, NP.plus(parseFloat(this.sendDataInfo.totalNumber), parseFloat(item.recPnumber)))
                });
                this.sendDataInfo.totalCount = newValue.length;
            },

            deep: true,
        },
        "sendDataInfo.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.sendDataInfo.smId = "";
                    this.sendDataInfo.salesId = "";
                    this.sendDataInfo.salesName = "";
                }
            },
            deep: true,
        },
        DialogVisible() {
            if (!this.DialogVisible) {
                this.nextSearch = false;
            }
        },
    },
    //方法集合
    methods: {
        rowClick(row) {
            this.selectedDetailsIndex = this.sendDataInfo.reconciliationDetails.indexOf(row)
            if (this.sendDataInfo.csrcType == 1) {
                this.detailsList = row.pisConciaExtOutVoList
            }
        },
        selection(val) {
            this.selectelist = val
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue == val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e, fField) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index, fField);
                        break;
                    }
                }
            }
        },
        selectChanges() {
            console.log(this.sendDataInfo.csrcType);
            this.sendDataInfo.reconciliationDetails = []
            this.detailsList = []
            this.detailsQuery()
        },
        //全款提取
        extract(formName) {
            this.parentData.list = this.sendDataInfo.reconciliationDetails
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.DialogExtract = true;
                    this.parentSearchData = {
                        coId: this.sendDataInfo.coId,
                        smId: this.sendDataInfo.smId,
                    }
                    this.seId = 8820873997127715
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });

                    return false;
                }
            });
        },
        //寄售提取
        extract1(formName) {
            this.parentData.list = this.sendDataInfo.reconciliationDetails
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.DialogExtract1 = true;
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        invoiceExtractMethods(val) {
            this.selectelist = val.mainData
            this.DialogExtract1 = false
            this.getExData()
        },

        //全款提取
        getExData() {
            let val = this.selectelist
            this.DialogExtract = false;
            // 检查 val 是否为有效的数组
            if (val && Array.isArray(val) && val.length > 0) {
                const mx = JSON.parse(JSON.stringify(val));
                // 处理单个数据项，合并默认数据和提取的数据
                const processItem = (item) => {
                    const obj = JSON.parse(JSON.stringify(this.detaislDataInfo));
                    Object.keys(obj).forEach(key => {
                        if (item[key] != null && item[key] !== '') {
                            obj[key] = item[key];
                        }
                    });
                    if (this.sendDataInfo.csrcType == 1) {
                        this.$set(obj, 'pisConciaExtOutVoList', item.pisConciaExtOutVoList)
                    }
                    return obj;
                };

                // 如果明细列表为空，直接赋值
                if (!this.sendDataInfo.reconciliationDetails || this.sendDataInfo.reconciliationDetails.length === 0) {
                    const processedItems = mx.map(item => processItem(item));
                    console.log(processedItems);
                    this.sendDataInfo.reconciliationDetails = processedItems;
                    if (this.sendDataInfo.csrcType === 0) {
                        this.sendDataInfo.reconciliationDetails.forEach((item, index) => {
                            this.calculate(1, index)
                        })
                    }
                    if (this.sendDataInfo.csrcType == 1) {
                        this.detailsList = this.sendDataInfo.reconciliationDetails[this.selectedDetailsIndex].pisConciaExtOutVoList
                    }
                    return;
                }

                // 创建现有商品UDI码的Set以提高查找性能，使用dapdId作为唯一标识
                const existingUdiCodes = new Set(
                    this.sendDataInfo.reconciliationDetails
                        .filter(detailItem => detailItem.dapdId != null && detailItem.dapdId !== '')
                        .map(detailItem => detailItem.dapdId)
                );
                // 只添加不重复的商品，使用dapdId作为唯一标识
                const newItems = mx
                    .filter(item => item.dapdId != null && item.dapdId !== '' && !existingUdiCodes.has(item.dapdId))
                    .map(item => processItem(item));

                console.log('新添加的商品数量:', newItems.length);
                // 使用展开运算符一次性添加所有新项目
                this.sendDataInfo.reconciliationDetails.push(...newItems);
                if (this.sendDataInfo.csrcType === 0) {
                    this.sendDataInfo.reconciliationDetails.forEach((item, index) => {
                        this.calculate(1, index)
                    })
                }
                if (this.sendDataInfo.csrcType == 1) {
                    this.detailsList = this.sendDataInfo.reconciliationDetails[this.selectedDetailsIndex].pisConciaExtOutVoList
                }
            } else {
                console.log('val 不是有效的数组或为空');
            }
        },

        calculate(cate, index) {
            this.selectedDetailsIndex = index
            var info = this.sendDataInfo.reconciliationDetails[index]
            if (this.sendDataInfo.csrcType == 1) {
                return
            } 
            else if (this.sendDataInfo.csrcType == 0) {
                // 处理 recPnumber 的边界条件，确保其在 0 和 treatCount 之间
                if (info.treatCount >= 0) {
                    // 当 treatCount 为非负值时，recPnumber 应在 [0, treatCount] 范围内
                    if (info.recPnumber > info.treatCount) {
                        info.recPnumber = info.treatCount;
                    } else if (info.recPnumber < 0) {
                        info.recPnumber = 0;
                    }
                } else {
                    // 当 treatCount 为负值时，recPnumber 应在 [treatCount, 0] 范围内
                    if (info.recPnumber > 0) {
                        info.recPnumber = 0;
                    } else if (info.recPnumber < info.treatCount) {
                        info.recPnumber = info.treatCount;
                    }
                }
            }

            switch (cate) {
                case 1:
                    //含税金额=含税价格*数量
                    this.sendDataInfo.reconciliationDetails[index].psmoney = this.$common.getDecimalInfo(3, NP.times(info.recPnumber, info.psprice))
                    // 计算金额 含税金额/(税率/100+1)
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.reconciliationDetails[index].psmoney, NP.plus(NP.divide((info.inRate ? info.inRate : 0), 100), 1)));
                    this.sendDataInfo.reconciliationDetails[index].money = this.$common.getDecimalInfo(3, midmoney);
                    break;

                default:
                    break;
            }
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        closeChild() {
            this.parentSearchData.bgmId = "";
            this.parentSearchData.bgmName = "";
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, flag, detailsFlag) {
            console.log(sId, index, type, sField, fField, flag, "测试");
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.detailsFlag = flag
            if (this.detailsFlag) {
                this.selectedDetailsIndex = this.seIndex
                this.parentSearchData[type] = this.sendDataInfo.reconciliationDetails[this.selectedDetailsIndex][type];
                if (type == "bgmName") {
                    this.isRepetition = false
                    if (flag) {
                        this.isRepetition = true
                        this.isRepetitionList = this.sendDataInfo.reconciliationDetails
                    }
                    for (let key in this.sendDataInfo) {
                        this.parentSearchData[key] = this.sendDataInfo[key];
                    }
                    if (!this.nextSearch)
                        this.parentSearchData.bgmName = this.sendDataInfo.reconciliationDetails[this.seIndex].bgmName;
                    if (this.parentSearchData.bgmName) {
                        let fh = 0;
                        if (this.parentSearchData.bgmName.indexOf(",") != -1) {
                            fh = ",";
                        } else if (this.parentSearchData.bgmName.indexOf("，") != -1) {
                            fh = "，";
                        }
                        if (fh !== 0) {
                            const str = this.parentSearchData.bgmName;
                            const list = str.split(fh);
                            this.parentSearchData.bgmName = list[0] || "";
                            this.parentSearchData.manufacturer = list[1] || "";
                        } else {
                            this.parentSearchData.manufacturer = "";
                        }
                    } else {
                        this.parentSearchData.bgmName = "";
                        this.parentSearchData.manufacturer = "";
                    }
                    this.selectedDetailsIndex = this.seIndex;
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.reconciliationDetails[this.selectedDetailsIndex]
                    );
                    return;
                }
            } else {
                if (type == "inStName") {
                    this.parentSearchData.stName = this.sendDataInfo.inStName;
                } else {
                    for (const key in this.sendDataInfo) {
                        if (this.sendDataInfo[key] != null && this.sendDataInfo[key] !== "") {
                            this.parentSearchData[key] = this.sendDataInfo[key];
                        } else {
                            this.parentSearchData[key] = ""
                        }
                    }
                }
            }

        },
        //检索带回数据
        changeInputModel(val) {
            console.log("返hui", val, this.sendDataInfo.reconciliationDetails);
            if (val != "" || val != undefined) {
                this.DialogVisible = false; //关闭商品检索窗口
                this.$nextTick(() => {
                    if (val.nextSearchId) {
                        this.nextSearch = true;
                        this.parentSearchData.bgmId = val.bgmId;
                        this.parentSearchData.bgmName = val.bgmName;
                        this.openSearch(val.nextSearchId, this.seIndex, "bgmName", "", "recPnumber", true, true);
                        return;
                    }
                    this.nextSearch = false;
                    if (this.seType == "bgmName") {
                        Object.keys(this.sendDataInfo.reconciliationDetails[this.selectedDetailsIndex]).forEach(item => {
                            if (val[item]) {
                                this.$set(this.sendDataInfo.reconciliationDetails[this.selectedDetailsIndex], item, val[item])
                            }
                        })
                        this.$nextTick(() => {
                            this.tableNextFocus(this.fField, this.selectedDetailsIndex);
                        });
                    } else {
                        this.paramValue(val)
                    }
                })

            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            if (this.detailsFlag) {
                arr.forEach((item) => {
                    this.sendDataInfo.reconciliationDetails[this.seIndex][item] = val[item];
                });
                this.$nextTick(() => {
                    this.tableNextFocus(this.fField, this.selectedDetailsIndex);
                });
            } else {
                arr.forEach((item) => {
                    this.sendDataInfo[item] = val[item];
                });
                this.$nextTick(() => {
                    this.nextFocus(this.seIndex, this.fField);
                });
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        // 确认新增
        async sendDataAction(formName) {
            let flag = false;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            sendData.reconciliationDetails = this.sendDataInfo.reconciliationDetails.filter(item => item.bgmId != "" || item.bgmId != null || item.bgmName != "" || item.bgmName != null)
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.reconciliationadd(sendData);
            } else {
                var responseData = await this.$http.reconciliationupdate(sendData);
            }
            if (responseData.status == 200) {
                this.$refs.operSelect.openBox(responseData.result);
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //取消新增
        initActionBox(formName) {
            this.$confirm("确定取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.init();
                    this.$emit("drawerCancel", 0);
                    this.$refs[formName].resetFields();
                })
                .catch(() => { });
        },
        conAdd() {
            this.dataActionBox.actionType = 0;
            this.filterMainField();
            this.checkIsBuyer();
        },
        drawerCancel() {
            this.$emit("drawerCancel", true);
        },
        async isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                return;
            }
            this.$refs[field][index].focus();
        },
        //删除明细
        deleteDetails() {
            if (this.sendDataInfo.reconciliationDetails.length < 1) {
                this.$message({
                    message: "请先添加明细",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.reconciliationDetails.splice(this.selectedDetailsIndex, 1);
            this.selectedDetailsIndex = 0;
            this.detailsList = []
            if (this.sendDataInfo.csrcType == 1) {
                this.detailsList = this.sendDataInfo.reconciliationDetails[0].pisConciaExtOutVoList
            }
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.createTime = this.$moment().valueOf()
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            this.sendDataInfo.reconciliationDetails = [];
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.filterMainField();

            console.log(this.dataActionBox.actionType, "2222");
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                if (this.sendDataInfo.csrcType == 1) {
                    if (this.sendDataInfo.reconciliationDetails.length > 0) {
                        this.detailsList = this.sendDataInfo.reconciliationDetails[0].pisConciaExtOutVoList
                    }
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                if (this.sendDataInfo.csrcType == 1) {
                    if (this.sendDataInfo.reconciliationDetails.length > 0) {
                        this.detailsList = this.sendDataInfo.reconciliationDetails[0].pisConciaExtOutVoList
                    }
                }
            }
            this.detailsQuery()
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                }, 16.7);
                this.initFocus();
            });
        },
        detailsQuery() {
            if (this.sendDataInfo.csrcType === 0) {//全款
                this.mxForm = this.mxFormList.filter(item => item.jciId == 117431496)[0].jurconfigform//全款,寄售的明细中的明细
            } else if (this.sendDataInfo.csrcType === 1) {//寄售
                this.mxForm = this.mxFormList.filter(item => item.jciId == 117431496)[0].jurconfigform//全款,寄售的明细中的明细
                this.mxForm1 = this.mxFormList.filter(item => item.jciId == 11743496)[0].jurconfigform//寄售明细
            }
            if (this.mxForm) {
                this.mxForm.forEach((item1) => {
                    if (item1.fieldType == "number") {
                        this.$set(this.detaislDataInfo, item1.entityField, 0);
                    } else if (item1.fieldType == "search" && item1.setField) {
                        var arr = item1.setField.split(",");
                        arr.forEach((item2) => {
                            this.$set(this.detaislDataInfo, item2, "");
                        });
                    } else {
                        this.$set(this.detaislDataInfo, item1.entityField, "");
                    }
                });
            }
            if (this.mxForm1) {
                this.mxForm1.forEach((item1) => {
                    if (item1.fieldType == "number") {
                        this.$set(this.detaislDataInfo1, item1.entityField, 0);
                    } else if (item1.fieldType == "search" && item1.setField) {
                        var arr = item1.setField.split(",");
                        arr.forEach((item2) => {
                            this.$set(this.detaislDataInfo1, item2, "");
                        });
                    } else {
                        this.$set(this.detaislDataInfo1, item1.entityField, "");
                    }
                });
            }
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.reconciliationDetails.length > 0) {
                }
                return;
            }
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex, fField);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.mxFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxFormList.push(item)
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "reconciliationDetails" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.sendDataInfo.createTime = this.$moment().valueOf()
            this.showTabs = this.tabForm[0].jciName;
            this.detailsQuery()
        },
        // 计算价格
        calculatePrice(cate = 1, index, flag) {
            var info = this.sendDataInfo.reconciliationDetails[index];
            if (info.recPnumber <= 0) {
                this.$message({
                    message: "请先填写合理的销售数量",
                    type: "error",
                });
                this.$set(this.sendDataInfo.reconciliationDetails[index], "recPnumber", 0);
                this.$set(this.sendDataInfo.reconciliationDetails[index], "money", 0);
                this.$set(this.sendDataInfo.reconciliationDetails[index], "psmoney", 0);
                this.$set(this.sendDataInfo.reconciliationDetails[index], "gross", 0); //毛利
                this.$set(this.sendDataInfo.reconciliationDetails[index], "costMoney", 0); //含税成本金额
                this.$set(this.sendDataInfo.reconciliationDetails[index], "costAmount", 0); //成本金额
                if (!flag) {
                    this.calculatePrice(cate, index, true)
                }
                return false;
            } else if (info.recPnumber > info.saleableNum) {
                this.sendDataInfo.reconciliationDetails[index].recPnumber = info.saleableNum;
                if (!flag) {
                    this.calculatePrice(cate, index, true)
                }
                this.$message({
                    message: "销售数量不能大于可销数量",
                    type: "error",
                });
                return
            }
            switch (cate) {
                case 2: // 通过含税价格计算全部
                    // this.getGoodsSockPrice(index)	//检测最低价/特价申请
                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo.reconciliationDetails[index].psmoney = info.recPnumber === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.recPnumber));
                    // 计算金额 含税金额/(税率/100+1)
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.reconciliationDetails[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)));
                    // var midmoney = NP.divide(this.sendDataInfo.reconciliationDetails[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
                    this.sendDataInfo.reconciliationDetails[index].money = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    this.sendDataInfo.reconciliationDetails[index].price = info.recPnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.recPnumber));
                    //计算税额
                    this.sendDataInfo.reconciliationDetails[index].taxAmount =
                        this.$common.getDecimalInfo(
                            3,
                            NP.minus(
                                this.sendDataInfo.reconciliationDetails[index].psmoney,
                                this.sendDataInfo.reconciliationDetails[index].money
                            )
                        );
                    this.sendDataInfo.reconciliationDetails[index].taxAmount =
                        this.sendDataInfo.reconciliationDetails[index].taxAmount == 0
                            ? 0
                            : this.sendDataInfo.reconciliationDetails[index].taxAmount;
                    break;
                case 4: // 通过含税金额计算全部
                    // 计算含税价格  含税金额 / 数量
                    // 计算总金额 含税金额/(税率/100+1)
                    var midmoney = this.$common.getDecimalInfo(
                        3,
                        NP.divide(
                            info.psmoney,
                            NP.plus(NP.divide(info.outRate, 100), 1)
                        )
                    );
                    // var midmoney = NP.divide(info.psmoney, NP.plus(NP.divide(info.outRate, 100), 1)).toFixed(10)
                    this.sendDataInfo.reconciliationDetails[index].money =
                        this.$common.getDecimalInfo(3, midmoney);
                    this.sendDataInfo.reconciliationDetails[index].psprice =
                        this.$common.getDecimalInfo(
                            2,
                            NP.divide(info.psmoney, info.recPnumber)
                        );
                    // 计算单价 金额/数量
                    this.sendDataInfo.reconciliationDetails[index].price =
                        info.recPnumber === 0
                            ? 0
                            : this.$common.getDecimalInfo(
                                2,
                                NP.divide(midmoney, info.recPnumber)
                            );
                    //计算税额
                    this.sendDataInfo.reconciliationDetails[index].taxAmount =
                        info.recPnumber === 0
                            ? 0
                            : this.$common.getDecimalInfo(
                                3,
                                NP.minus(
                                    info.psmoney,
                                    this.sendDataInfo.reconciliationDetails[index].money
                                )
                            );
                    this.sendDataInfo.reconciliationDetails[index].taxAmount =
                        this.sendDataInfo.reconciliationDetails[index].taxAmount == 0
                            ? 0
                            : this.sendDataInfo.reconciliationDetails[index].taxAmount;
                    break;
                default:
                    this.sendDataInfo.reconciliationDetails[index].saleQumoney = this.$common.getDecimalInfo(3, NP.times(info.saleQuprice || 0, info.recPnumber));
                    //通过数量计算
                    // 计算含税金额 含税价格*数量
                    var midmoney = info.recPnumber === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.recPnumber));
                    // var midmoney = info.recPnumber === 0 ? 0 : NP.times(info.psprice, info.recPnumber).toFixed(10);
                    this.sendDataInfo.reconciliationDetails[index].psmoney =
                        this.$common.getDecimalInfo(3, midmoney);
                    // 计算总金额 含税金额/(税率/100+1)
                    this.sendDataInfo.reconciliationDetails[index].money = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.reconciliationDetails[index].psmoney, NP.plus(NP.divide(info.outRate, 100), 1)));
                    // 计算单价 金额/数量
                    this.sendDataInfo.reconciliationDetails[index].price = info.recPnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(this.sendDataInfo.reconciliationDetails[index].money, info.recPnumber));
                    // 计算 wholeNum整件数量  recPnumber 销售数量    整件数量= 销售数量/装箱规格
                    var wholeNum = info.packingSpec > 0 && info.recPnumber > 0 ? Math.floor(NP.divide(info.recPnumber, Number(info.packingSpec))) : 0
                    this.sendDataInfo.reconciliationDetails[index].wholeNum = wholeNum
                    //计算 scatNum 零散数量   wholeNum 整件数量   packingSpec 装箱规格    零散数量=销售数量-(整件数量*装箱规格)
                    var scatNum = NP.minus(this.$common.getDecimalInfo(1, info.recPnumber), NP.times(this.sendDataInfo.reconciliationDetails[index].wholeNum, Number(info.packingSpec)))
                    this.sendDataInfo.reconciliationDetails[index].scatNum = String(scatNum) == 'NaN' ? 0 : scatNum;
                    //计算税额
                    this.sendDataInfo.reconciliationDetails[index].taxAmount = info.recPnumber === 0 ? 0 : this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.reconciliationDetails[index].psmoney, this.sendDataInfo.reconciliationDetails[index].money));
                    this.sendDataInfo.reconciliationDetails[index].taxAmount = this.sendDataInfo.reconciliationDetails[index].taxAmount == 0 ? 0 : this.sendDataInfo.reconciliationDetails[index].taxAmount;
                    // 含税成本金额 = 含税成本 * 数量
                    this.sendDataInfo.reconciliationDetails[index].costMoney = this.$common.getDecimalInfo(3, NP.times(info.woadWcost, info.recPnumber));
                    // 成本金额 = 库存成本 * 数量
                    this.sendDataInfo.reconciliationDetails[index].costAmount = this.$common.getDecimalInfo(3, NP.times(info.costPrice, info.recPnumber));
                    // 计算件数 采数/包装单位  件数=销售数量/装箱规格
                    if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
                        this.sendDataInfo.reconciliationDetails[index].pieceNum = 0;
                    } else {
                        this.sendDataInfo.reconciliationDetails[index].pieceNum = this.$common.getDecimalInfo(1, NP.divide(info.recPnumber, info.packingSpec));
                    }
                    break;
            }
            this.sendDataInfo.reconciliationDetails[index].disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0))
            // 含税金额
            var moneyFour = this.sendDataInfo.reconciliationDetails[index].psmoney;
            // 含税成本金额
            var moneyFive = this.sendDataInfo.reconciliationDetails[index].costMoney;

            // 毛利 = 含税金额 - 成本含税金额
            this.sendDataInfo.reconciliationDetails[index].gross =
                this.$common.getDecimalInfo(3, NP.minus(moneyFour, moneyFive));

            // 不含税毛利 = 金额 - 成本金额
            this.sendDataInfo.reconciliationDetails[index].taxgross =
                this.$common.getDecimalInfo(
                    3,
                    NP.minus(info.money, info.costAmount)
                );
            //毛利率
            this.sendDataInfo.reconciliationDetails[index].grossProfit = moneyFour != 0 ? this.$common.toFixed2(NP.divide(this.sendDataInfo.reconciliationDetails[index].gross, moneyFour), 2) : 0;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-drawer {
    outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>